import React, { Component } from 'react';
import { connect } from '@cerebral/react';
import { signal } from 'cerebral/tags';
import { Element } from 'react-scroll';

import Page from './pages';
import preloadImages from './preloadImages';

class App extends Component {
    componentWillMount() {
        this.props.init();
        window.addEventListener('beforeunload', (e) => {
            e.preventDefault();
            e.returnValue = ''; //eslint-disable-line
            return '';
        });
    }

    componentDidMount() {
        const { cdn } = this.props;
        preloadImages.forEach((picture) => {
            const img = new Image();
            img.src = `${cdn}${picture}`;
        });
    }

    render() {
        return (
            <React.Fragment>
                <Element name="anchor" />
                <Page />
            </React.Fragment>
        );
    }
}
const stateSignals = {
    init: signal`app.init`,
};
export default connect(stateSignals, App);



// WEBPACK FOOTER //
// ./src/App.js